import React from "react";
import { FollowExperiencePage } from "../Follow/FollowExperiencePage";
import { BubblePage } from "../Share/BubblePage";
import { BubblePage as BubblePage2 } from "../Share2/BubblePage";
import { BubblePage as BubblePage3 } from "../Share3/BubblePage";
import { VisualPage } from "../Visual/VisualPage";
import { DerivedVisualPage } from "../DerivedVisual/DerivedVisualPage";
import { VideoPassionsV3 } from "../../pages/CampaignPage/VideoPassions/VideoPassionsV3";
import { NotFoundPage } from "~/pages";
import { CAMPAIGN_NOT_FOUND_PAGE_NAME } from "~/pages/NotFoundPage/notFoundRedirect";
import { InteractivePage } from "../Interactive/InteractivePage";
import { BeverageLanding } from "../../pages/Beverage";
import { BeverageV2 } from "../../pages/BeverageV2/Beverage";
import { BeverageV3Landing } from "../../pages/BeverageV3";
import { BeverageV4 } from "../../pages/BeverageV4/Beverage";
import { BeverageLandingV5 } from "../../pages/BeverageV5/BeverageLanding";
import { BeverageV6 } from "../../pages/BeverageV6/Beverages";
import { BeverageV7 } from "../../pages/BeverageV7/Beverages";
import { BeveragesSplit } from "../../pages/BeveragesSplit";
import styles from "./RenderCampaign.module.css";

function getExperience(expId) {
  switch (expId) {
    case "follow":
      return <FollowExperiencePage />;
    case "share":
      return <BubblePage />;
    case "share2":
      return <BubblePage2 />;
    case "share3":
      return <BubblePage3 />;
    case "golf":
      return <DerivedVisualPage />;
    case "video":
      return <VideoPassionsV3 />;
    case "video3":
      return <VideoPassionsV3 />;
    case "interactive":
      return <InteractivePage />;
    case "beverage":
      return <BeverageLanding />;
    case "beverage2":
      return <BeverageV2 />;
    case "beverage3":
      return <BeverageV3Landing />;
    case "beverage4":
      return <BeverageV4 />;
    case "beverage5":
      return <BeverageLandingV5 />;
    case "beverage6":
      return <BeverageV6 />;
    case "beverage7":
      return <BeverageV7 />;
    case "beverage-split":
      return <BeveragesSplit />;
    default:
      return null;
  }
}

export function MarriottCampaignData({ expId, showNotFound }) {
  if (!showNotFound) {
    const experience = getExperience(expId);
    if (experience) {
      return (
        <div className={styles.wrapper}>
          <div className={styles.wrapper}>{experience}</div>
        </div>
      );
    }
  }

  return (
    <NotFoundPage
      trackValue="Campaign Not Found Page|Home Button"
      pageName={CAMPAIGN_NOT_FOUND_PAGE_NAME}
    />
  );
}
